<template>
  <div class="login-form">
    <div class="btns">
      <h3>忘记密码</h3>
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="0"
      class="form"
    >
      <el-form-item prop="phone">
        <el-input
          v-model="ruleForm.phone"
          placeholder="请输入您的手机号码"
          minlength="11"
          maxlength="11"
        ></el-input>
      </el-form-item>
      <el-form-item prop="captcha">
        <el-row>
          <el-col :span="12"
            ><el-input
              v-model="ruleForm.captcha"
              placeholder="请输入验证码"
            ></el-input
          ></el-col>
          <el-col :span="12">
            <el-button
              class="captcha-btn"
              @click="getCaptcha"
              :disabled="captchaDisabled"
              >获取验证码<span v-if="showCountdown"
                >({{ seconds }}s)</span
              ></el-button
            >
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')" size="small"
          >下一步</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "ResetPassword",
  mounted() {
    this.from = this.$route.query["from"];
    console.log(this.from);
  },

  data() {
    return {
      from: "/",
      ruleForm: {
        phone: "",
        captcha: "",
      },
      rules: {
        phone: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          { min: 11, max: 11, message: "手机号码格式不正确", trigger: "blur" },
        ],
        captcha: [
          { required: true, message: "验证码不能为空", trigger: "blur" },
        ],
      },
      seconds: 60,
      captchaDisabled: false,
      showCountdown: false,
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$router.push({
            path:
              "/resetpassword?mobile=" +
              this.ruleForm.phone +
              "&code=" +
              this.ruleForm.captcha,
          });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getCaptcha() {
      this.seconds = 60;
      this.captchaDisabled = true;
      this.showCountdown = true;
      this.$http
        .get("/fireeye/public/code/pass/reset?mobile=" + this.ruleForm.phone)
        .then(
          (res) => {
            let data = res.data;
            console.log(data);
            if (data.code == 1) {
              this.$message.success("验证码已发送，请注意查收！");
            } else {
              this.$message.error("验证码发送失败，请重新尝试！");
            }
          },
          () => {
            this.captchaDisabled = false;
            this.showCountdown = false;
          }
        );
      let interval = setInterval(() => {
        this.seconds--;
        if (this.seconds <= 0) {
          clearInterval(interval);
          this.captchaDisabled = false;
          this.showCountdown = false;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.captcha-btn {
  float: right;
}
</style>